import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';


import Estado from './EstadoPostulacion'; 

class TablaPostulacion extends Component {

    render(){
        const {listado, toggleModal, postulacion} = this.props;

        return (

                <div>
                    {
                    listado.length>0 ? (   

                        <Table size="sm" striped bordered className="tabla-general">


                        <thead>
                            <tr>
                                <th>RUN</th>
                                <th className="ocultar-en-somen">Nombre estudiante</th>
                                <th className="text-center">Fecha</th>
                                <th className="text-center">Postulación</th>
                                <th className="text-center ocultar-en-somen">Estado postulación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listado.map(p => {

                                    return(
                                        <tr key={p.id}>
                                            <td>{p.rut}</td>
                                            <td className="ocultar-en-somen">{p.nombres} {p.apellidos}</td>
                                            <td className="ocultar-en-somen text-center">{p.fecha}</td>
                                            <td className="text-center">
                                                {
                                                    p.estado==="Aceptada" ? (
                                                    <span> Aceptada</span>
                                                    ) : 
                                                    (
                                                        <Button outline color="primary" className="btn-tabla" onClick={()=>{toggleModal(); postulacion(p)}}>VER POSTULACIÓN</Button>
                                                    )
                                                }
                                                    
                                            </td>
                                            <td className="text-center">
                                                <Estado tipo={p.estado}/>
                                            </td>
                                        </tr>
                                    )
                                }) 
                            }


                        </tbody>


                        </Table>  


                        ) : (<div className="sin-registros">Sin registros</div>)

                    }
                 </div> 

        );

    }
};

export default TablaPostulacion;
